const normalizeData = (data) => typeof data === 'string' ? data.toString().toLowerCase() : '';

export const car = {
  namespaced: true,
  state: {
    chosenCarSpecs: {
      licensePlate: '',
      vin: '',
      model: '',
      engine: '',
      power: '',
      transmission: '',
      capacity: '',
      name: '',
      id: '',
    },
    filters: {
      model: '',
      transmission: '',
      capacity: '',
      power: '',
      engine: '',
    },
    filteredCars: [],
  },
  getters: {
    getChosenCarSpecs(state) {
      return state.chosenCarSpecs;
    },
    getFilteredCars(state) {
      return state.filteredCars;
    },
    getFilters(state) {
      return state.filters;
    },
  },
  mutations: {
    setLicensePlate(state, licensePlate) {
      state.chosenCarSpecs.licensePlate = licensePlate;
    },
    setVinNumber(state, vin) {
      state.chosenCarSpecs.vin = vin;
    },
    setModel(state, model) {
      state.chosenCarSpecs.model = normalizeData(model);
    },
    setName(state, name) {
      state.chosenCarSpecs.name = normalizeData(name);
    },
    setEngine(state, engine) {
      state.chosenCarSpecs.engine = normalizeData(engine);
    },
    setId(state, id) {
      state.chosenCarSpecs.id = id;
    },
    setPower(state, power) {
      state.chosenCarSpecs.power = power;
    },
    setCapacity(state, capacity) {
      state.chosenCarSpecs.capacity = capacity;
    },
    setTransmission(state, transmission) {
      state.chosenCarSpecs.transmission = normalizeData(transmission);
    },
    setFilteredCars(state, cars) {
      state.filteredCars = cars;
    },
    setFilters(state, filter) {
      state.filters[filter.type] = filter.value;
    },
    resetFilters(state) {
      state.filters = {
        model: '',
        transmission: '',
        capacity: '',
        power: '',
        engine: '',
      };
    },
  },
  actions: {
    setModalState({ commit }, modalState) {
      commit('setModalState', modalState);
    },
    resetCarSpecs({ commit }) {
      commit('setVinNumber', '');
      commit('setLicensePlate', '');
      commit('setModel', '');
      commit('setEngine', '');
      commit('setTransmission', '');
      commit('setPower', '');
      commit('setCapacity', '');
      commit('setName', '');
      commit('setId', '');
    },
    resetLicensePlate({ commit }) {
      commit('resetLicensePlate', '');
    },
    resetFilters({ commit }) {
      commit('resetFilters');
    },
    setFilters({ commit }, data) {
      if (Array.isArray(data)) {
        data.forEach((filter) => {
          commit('setFilters', filter);
        });
      } else {
        commit('setFilters', data);
      }
    },
    filterCars({ commit, state, rootState }) {
      const allCars = rootState.brand.specificModels;
      const cars = allCars.filter((auto) => {
        /* eslint-disable */
        for (const filter in state.filters) {
          if (state.filters[filter] !== '' && state.filters[filter] != auto[filter]) { return false; }
        }
        /* eslint-disable */
        return true;
      });
      commit('setFilteredCars', cars);
    },
    setLicensePlate({ commit }, value) {
      commit('setLicensePlate', value);
    },
    setVinNumber({ commit }, value) {
      commit('setVinNumber', value);
    },
    setModel({ commit, rootState }, value) {
      let model = value;
      if (value === undefined) {
        const { generalModels } = rootState.brand;
        model = generalModels[0];
      }
      commit('setModel', model);
    },
    setEngine({ commit }, value) {
      commit('setEngine', value);
    },
    setTransmission({ commit }, value) {
      commit('setTransmission', value);
    },
    setId({ commit }, value) {
      commit('setId', value);
    },
    setPower({ commit }, value) {
      commit('setPower', value);
    },
    setCapacity({ commit }, value) {
      commit('setCapacity', value);
    },
    chooseCar({ dispatch, state }) {
      dispatch('setEngine', state.filteredCars[0].engine);
      dispatch('setTransmission', state.filteredCars[0].transmission);
    },
    searchForChosenCarName({ commit, state, rootState }) {
      const allCars = rootState.brand.specificModels;
      const { model, engine, transmission, power, capacity } = state.chosenCarSpecs;
      const chosenCarObject = allCars.find(carObj => {
        return normalizeData(carObj.model) == model &&
            normalizeData(carObj.engine) == engine &&
            normalizeData(carObj.transmission) == transmission &&
            carObj.power == power &&
            carObj.capacity == capacity;
      });

      commit('setName', chosenCarObject.name);
      commit('setId', chosenCarObject.id);
    },
  },
};
